import { ChargeZemComplete } from '../../../components/service/accounts/charge';
export const ChargeZemCompletePageView = () => {
  return <ChargeZemComplete data-sentry-element="ChargeZemComplete" data-sentry-component="ChargeZemCompletePageView" data-sentry-source-file="complete.tsx" />;
};